import { Component, OnInit, OnDestroy, DoCheck, ElementRef, ViewChild } from "@angular/core";
import { Router } from '@angular/router';
import { Utils } from '../../../shared/utils/utils';
import { SharedService } from '../../services/store/shared-store/shared-storage.service';

import { FileClickEmitter } from '../../../shared/components/clickatell-tree/clickatell-tree.interface';
import {Observable, Subscription} from 'rxjs';
import find from 'lodash/find';
import { OAuthService } from 'angular-oauth2-oidc';
import { SharedStorageService } from 'ngx-store';
import { RolesService } from '../../services/roles/roles.service';
import { FlowWebSocketsService } from '../../../modules/flow/services/flowBuilder/flow-web-sockets.service';
import { FlowManagerService } from '../../../modules/flow/services/flow-manager.service';
import {Store} from '@ngrx/store';
import { selectFlowModeState } from '../../state';
import { filter, take } from 'rxjs/operators';
import {
  defineBlueVariablesTheme,
  defineDefaultBlueTheme,
  registerFlowVariablesLanguage
} from '../../../shared/utils/monacoEditorUtils/monaco-editor-config';
import {MonacoEditorLoaderService} from '@materia-ui/ngx-monaco-editor';
import { FlowModeState } from '../../../shared/models/state/Flow';

// declare let jQuery: any;

@Component({
  selector: 'app-main-area',
  templateUrl: './main-area.component.html',
  styleUrls: ['./main-area.component.css'],
})
export class MainAreaComponent implements OnInit, OnDestroy, DoCheck {
  isNightMode = false;
  theme = 'light';

  title = 'app';
  userName: any;
  userInfo: any = {
    roles: [],
  };

  flow: any;
  getFlows$: Subscription;
  searchForStep: string;
  tempFlowPath: string;
  tempRoutePath: string;
  requestFlowLoad: string;
  requestRouteLoad: string;
  globalEnvironment;
  flowState$: Observable<FlowModeState>;
  private monacoEditorSubscription: Subscription;

  @ViewChild('componentArea') componentArea: ElementRef;

  constructor(
    private router: Router,
    private sharedService: SharedService,
    private flowWebSocketsService: FlowWebSocketsService,
    private flowManagerService: FlowManagerService,
    private utils: Utils,
    private oauthService: OAuthService,
    private sharedStorageService: SharedStorageService,
    private rolesService: RolesService,
    private store: Store,
    private monacoLoaderService: MonacoEditorLoaderService
  ) {}

  ngOnInit() {
    if (!this.sharedService.getLoggedIn()) {
      this.oauthService.loadDiscoveryDocumentAndTryLogin().then((isLoggedIn) => {
        if (isLoggedIn) {
          let storedUserInfo = this.sharedStorageService.get('userInfo');
          if (storedUserInfo == null) {
            storedUserInfo = this.utils.getUserInfo();
            this.initializeWithUserInfo(storedUserInfo);
          } else {
            this.initializeWithUserInfo(storedUserInfo);
          }
        }
      });
    } else {
      document.getElementById('lockContainer').style.visibility = 'hidden';
      this.userName = this.sharedService.getUserInfo().name;
      document.getElementsByTagName('body')[0].className = this.theme;
      document.getElementById('icon').className =
        'payd_icon navbar-brand-icon payd-icon-nav ' + this.theme;
      // jQuery('#lockContainer').tooltip({
      //   template:
      //     '<div class="lockContainer tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
      // });
    }

    this.globalEnvironment = Object.assign({}, this.sharedService.getGlobalEnvironment());
    this.flowState$ = this.store.select(selectFlowModeState);
    this.monacoEditorSubscription = this.initializeMonacoEditor();
  }

  ngOnDestroy(): void {
    this.getFlows$.unsubscribe();
    this.monacoEditorSubscription?.unsubscribe();
  }

  ngDoCheck(): void {
    if (this.sharedService.getRequestFlowLoad() !== this.requestFlowLoad) {
      this.requestFlowLoad = this.sharedService.getRequestFlowLoad();
      if (this.requestFlowLoad === 'load') {
        this.sharedService.setFlowPathName(this.tempFlowPath);
        this.router.navigate([
          'flow',
          this.sharedService.getEnvironment(),
          this.sharedService.getEntityType(),
          this.sharedService.getEntityId(),
          this.sharedService.getFlowPathName(),
        ]);
        this.sharedService.setRequestFlowLoad('');
      }
    }

    if (this.sharedService.getRequestRouteLoad() !== this.requestRouteLoad) {
      this.requestRouteLoad = this.sharedService.getRequestRouteLoad();
      if (this.requestRouteLoad === 'load') {
        // this.sharedService.setFlowName(null);
        this.route(this.tempRoutePath);
      }
    }

    if (
      JSON.stringify(this.globalEnvironment) !==
      JSON.stringify(this.sharedService.getGlobalEnvironment())
    ) {
      this.flowWebSocketsService.entityChange();
      this.globalEnvironment = Object.assign({}, this.sharedService.getGlobalEnvironment());
    }
  }

  /**
   * Initialize Monaco Editor and create a custom theme
   */
  private initializeMonacoEditor() {
    return this.monacoLoaderService.isMonacoLoaded$.pipe(
        filter(isLoaded => !!isLoaded),
        take(1)
    ).subscribe(() => {
      defineDefaultBlueTheme();
      registerFlowVariablesLanguage();
      defineBlueVariablesTheme();
    });
  }

  route(path: string) {
    this.router.navigate([path]);
    if (path === '/') {
      this.utils.setSelectedRoute('/');
    }
  }

  private initializeWithUserInfo(userInfo) {
    // console.log(userInfo);
    this.userInfo = userInfo;
  }

  logoutUrl(): void {
    this.oauthService.logOut();
  }

  changeMode() {
    this.isNightMode = !this.isNightMode;
    if (this.isNightMode) {
      this.theme = 'dark';
      document.getElementsByTagName('body')[0].className = this.theme;
      document.getElementById('icon').className =
        'payd_icon navbar-brand-icon payd-icon-nav ' + this.theme;
    } else {
      this.theme = 'light';
      document.getElementsByTagName('body')[0].className = this.theme;
      document.getElementById('icon').className =
        'payd_icon navbar-brand-icon payd-icon-nav ' + this.theme;
    }
  }

  openFlow(event: FileClickEmitter) {
    this.tempFlowPath = event.path.split('/').join(',');
    let path = '';
    if (this.sharedService.getIsFlowChanged()) {
      this.sharedService.setRequestFlowLoad('request');

      path = event.path.replace(/\//g, ',');

      if (this.sharedService.getFlowPathName() !== this.sharedService.getNewFlowName()) {
        this.sharedService.setFlowPathName(path);
      }
    } else if (this.router && this.sharedService.getFlowPathName() !== this.tempFlowPath) {
      path = this.tempFlowPath;

      this.flowManagerService.getFlowMetaData(true).subscribe((value) => {
        const flowId: String = this.tempFlowPath;
        const flow = find(value, { flowId });
        if (flow) {
          this.sharedService.setFlowName = flow.flowName;
          this.sharedService.setFlowPathName(flow.directory);
        }
      });
    }
    if (!this.rolesService.canEditFlows() && path === '__NEW_FLOW__') {
      this.router.navigate(['/']);
    } else {
      this.router.navigate([
        'flow',
        this.sharedService.getEnvironment(),
        this.sharedService.getEntityType(),
        this.sharedService.getEntityId(),
        event.name,
      ]);
    }


  }

  openRoute(event: string) {
    this.route(event);
  }

  searchForNode(value: string) {
    if (this.flow) {
      this.searchForStep = value;
    } else {
      console.error('There are no nodes to search for.');
    }
  }
}
